import { render, staticRenderFns } from "./RoadmapBaseEventFilesList.vue?vue&type=template&id=701397c9&"
import script from "./RoadmapBaseEventFilesList.vue?vue&type=script&lang=js&"
export * from "./RoadmapBaseEventFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports